<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2024-02-20 17:05:02
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-05 18:34:15
 * @Description: description
-->
<template>
  <div class="my-info component-container">
    <div class="container-body myInfo-main-container">
      <div class="main-panel-left">
        <span
          class="user-avatar-view"
          :style="`background-image: url(${avatarPre}/${baseInfo.avatar})`"
        />
      </div>
      <div class="main-panel-right">
        <div class="user-name-and-gender">
          <span class="user-name"
            >{{ baseInfo.name }}
            <span
              class="user-gender iconfont"
              :class="
                baseInfo.gender === '1'
                  ? 'icon-nan1'
                  : baseInfo.gender === '0'
                  ? 'icon-nv'
                  : ''
              "
            >
            </span>
          </span>
          <span class="user-phone">{{ baseInfo.userId }}</span>
        </div>
        <span class="user-tag">
          <el-tag type="success" v-if="baseInfo.titleLv1">
            {{ baseInfo.titleLv1 }}</el-tag
          >
          <el-tag type="success" v-if="baseInfo.titleLv2">
            {{ baseInfo.titleLv2 }}</el-tag
          >
        </span>
      </div>
    </div>
    <div class="container-body myInfo-other-container">
      <el-form
        ref="form"
        :model="form.data"
        :rules="formRules"
        label-width="100px"
      >
        <el-row :gutter="20">
          <el-col :span="defaultSpan" v-if="form.data.name">
            <el-form-item label="用户名称" prop="name">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.name
              }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.gender">
            <el-form-item label="性别">
              <span
                class="dialog-body-data-text"
                v-if="form.data.gender === '1'"
                >&nbsp;&nbsp;&nbsp; 男</span
              >
              <span class="dialog-body-data-text" v-else
                >&nbsp;&nbsp;&nbsp; 女</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.birth">
            <el-form-item label="出生日期">
              <span class="dialog-body-data-text"
                >&nbsp;&nbsp; &nbsp;{{ form.data.birth | dateFormat }}</span
              >
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.politicTpCode">
            <el-form-item label="政治面貌">
              <span v-for="(item, index) in codes['009']" :key="index">
                <span
                  v-if="item.cd == form.data.politicTpCode"
                  class="dialog-body-data-text"
                >
                  {{ "&nbsp  &nbsp " + item.cdDesc }}</span
                >
              </span>
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.educationCode">
            <el-form-item label="学历">
              <span
                v-for="(item, index) in eduAndDegcodes.educationCodes"
                :key="index.id"
              >
                <span
                  v-if="item.cd == form.data.educationCode"
                  class="dialog-body-data-text"
                >
                  {{ "&nbsp  &nbsp " + item.cdDesc }}
                </span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.degreeCode">
            <el-form-item label="学位">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.degreeDesc
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.unitName">
            <el-form-item label="单位名称">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.unitName
              }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.titleTpCode">
            <el-form-item label="职称">
              <span
                class="dialog-body-data-text"
                v-for="(item, index) in codes['015']"
                :key="index"
              >
                <span v-if="item.cd == form.data.titleTpCode">
                  {{ "&nbsp  &nbsp " + item.cdDesc }}
                </span>
              </span>
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.showSecondTpCode">
            <el-form-item label="第二职称">
              <span
                class="dialog-body-data-text"
                v-for="(item, index) in codes['015']"
                :key="index"
                v-show="item.cd == form.data.secondTpCode"
              >
                {{ "&nbsp  &nbsp " + item.cdDesc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.administrative">
            <el-form-item label="行政职务">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.administrative
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.tutorTpCode">
            <el-form-item label="导师类型">
              <span
                class="dialog-body-data-text"
                v-for="(item, index) in codes['011']"
                :key="index"
              >
                <span v-if="item.cd == form.data.tutorTpCode">
                  {{ "&nbsp  &nbsp " + item.cdDesc }}
                </span>
              </span>
            </el-form-item>
          </el-col>
          <el-col
            :span="defaultSpan"
            v-if="
              (form.data.tutorTpCode === '011-002' ||
                form.data.tutorTpCode === '011-003') &&
                form.data.tutorObtainTime
            "
          >
            <el-form-item label="导师获得时间">
              <span class="dialog-body-data-text"
                >&nbsp;&nbsp; &nbsp;{{
                  form.data.tutorObtainTime | dateFormat
                }}</span
              >
            </el-form-item>
          </el-col>

          <el-col :span="defaultSpan" v-if="form.data.directionLv1TpCode">
            <el-form-item label="一级研究方向">
              <span
                class="dialog-body-data-text"
                v-for="(item, index) in codes['012']"
                :key="index"
              >
                <span v-if="item.cd == form.data.directionLv1TpCode">
                  {{ "&nbsp  &nbsp " + item.cdDesc }}
                </span>
              </span>
            </el-form-item>
          </el-col>

          <el-col
            :span="defaultSpan"
            v-if="
              (!directionLv2Codes || directionLv2Codes.length > 0) &&
                form.data.directionLv2TpCode
            "
          >
            <el-form-item label="二级研究方向">
              <span
                class="dialog-body-data-text"
                v-for="(item, index) in codes['013']"
                :key="index"
              >
                <span v-if="item.cd == form.data.directionLv2TpCode">
                  {{ "&nbsp  &nbsp " + item.cdDesc }}
                </span>
              </span>
            </el-form-item>
          </el-col>
          <el-col
            :span="defaultSpan"
            v-if="
              form.data.directionLv2 === otherDirectionStr &&
                form.data.directionLv2Desc
            "
          >
            <el-form-item label="其他方向" prop="directionLv2Desc">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.directionLv2Desc
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.userId">
            <el-form-item label="手机号">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.userId
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.mail">
            <el-form-item label="邮箱" ref="mail">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.mail
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.inviteUserName">
            <el-form-item label="邀请人">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.inviteUserName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.createTime">
            <el-form-item label="注册时间">
              <span class="dialog-body-data-text"
                >&nbsp;&nbsp; &nbsp;{{
                  form.data.createTime | dateFormat
                }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.departmentName">
            <el-form-item label="机构">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.departmentName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="defaultSpan" v-if="form.data.nativePlace">
            <el-form-item label="籍贯">
              <span class="dialog-body-data-text">{{
                "&nbsp  &nbsp " + form.data.nativePlace
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.data.expertise">
            <el-form-item label="擅长领域" disabled>
              <textarea
                v-model="form.data.expertise"
                :disabled="form.config.isDisable"
                style="width: calc( 100% - 40px);;height: 150px"
              ></textarea>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <animation
      :loading-data-visible="form.config.isLoading"
      :loading-text="form.config.loadingText"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import Animation from "@/components/loading/animation";
import { Message } from "element-ui";
import { AVATAR_UPLOAD_COMPONENT_TYPE_STR } from "@/constants/constants";
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
import * as constantsRules from "@/constants/constantRules";

export default {
  name: "MyInfo",
  components: { Animation },
  props: {
    //表示是否操作标识类型 view add update
    userId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      //form表单的默认span
      defaultSpan: 12,
      //form表单换行的灵敏度
      defaultSensitive: 500,

      pickerOptions: {
        //设置不可选中今日之后的时间
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },

      form: {
        config: {
          loadingText: "加载中",
          isLoading: false,
          isDisable: true
        },
        data: {
          userId: "",
          name: "",
          gender: "",
          mail: "",
          title: "",
          nativePlace: "",
          tutorObtainTime: "",
          expertise: "",
          unitName: "",
          educationCode: "",
          degreeCode: "",
          degreeDesc: "",
          titleExTpCode: "",
          secondExTpCode: "",
          titleTpCode: "",
          secondTpCode: "",
          showTitleTpCode: [],
          showSecondTpCode: []
        },
        copy: {},

        //是否初始化的数据
        immediate: false
      },

      baseInfo: {
        userId: "",
        name: "",
        gender: "",
        title: "",
        nativePlace: "",
        tutorObtainTime: "",
        expertise: "",
        unitName: "",
        educationCode: "",
        degreeCode: "",
        degreeDesc: "",
        titleExTpCode: "",
        secondExTpCode: "",
        titleTpCode: "",
        secondTpCode: "",
        showTitleTpCode: "",
        showSecondTpCode: ""
      },

      eduAndDegcodes: {
        educationCodes: [],
        degreeCodes: []
      },
      codes: [],
      showTitleTpCode: [],
      showSecondTpCode: [],

      avatarPre: window.config.avatar.baseUrl,
      attaFileSuf: AVATAR_UPLOAD_COMPONENT_TYPE_STR,
      learnIndex: null, //学历信息的全局索引

      //二级方向的数组数据
      directionLv2: [],
      otherDirectionStr: "其他",
      titleTpCodes: [],
      secondTpCodes: [],

      formRules: {
        name: constantsRules.BasicInfoRules.name,
        mail: [
          { min: 1, max: 50, message: "长度在 50 个字符之内", trigger: "blur" },
          {
            validator(rule, value, callback) {
              const reg = /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
              if (reg.test(value) || !value) {
                callback();
              } else {
                callback(new Error("请输入合法邮箱地址"));
              }
            }
          }
        ],
        directionLv2Desc: constantsRules.BasicInfoRules.directionLv2Desc
      }
      // editFlag :null,
    };
  },

  computed: {
    //遍历获取职称小类的数据
    titleLv2TpCodes() {
      if (!this.codes["015"]) {
        return;
      }
      let titleLv1TpCode = this.form.data.titleLv1TpCode;
      let result = [];
      for (let code of this.codes["015"]) {
        if (code.parentCd === titleLv1TpCode) {
          result.push(code);
        }
      }
      return result;
    },

    secondLv2TpCodes() {
      if (!this.codes["015"]) {
        return;
      }
      let secondLv1TpCode = this.form.data.secondLv1TpCode;
      let result = [];
      for (let code of this.codes["015"]) {
        if (code.parentCd === secondLv1TpCode) {
          result.push(code);
        }
      }
      return result;
    },
    //遍历二级研究方向的数据
    directionLv2Codes() {
      if (!this.codes["013"]) {
        return;
      }
      let directionLv1TpCode = this.form.data.directionLv1TpCode;
      let result = [];
      for (let code of this.codes["013"]) {
        if (code.parentCd === directionLv1TpCode) {
          result.push(code);
        }
      }
      return result;
    }
  },

  mounted() {
    this.initPage();
    window.addEventListener("resize", this.initPage);
    // this.editFlag=(this.$store.state.MemberManageModule.userId==null&& !['view','update'].includes(this.$store.state.MemberManageModule.type))?true:false
  },
  created() {
    this.getBaseCodes();
    this.getLearnCodes();
  },

  watch: {
    "form.data.directionLv2TpCode"(newVal) {
      let codes = this.codes["013"];
      if (codes) {
        for (let code of codes) {
          if (code.cd === newVal) {
            this.form.data.directionLv2 = code.cdDesc;
            break;
          }
        }
      }
    },

    "form.data.directionLv1TpCode"(newVal) {
      //在非初始化的数据的时候才需要设置二级会显得的数据,否则会出现错误监听的导致回显的数据错误的问题
      if (!this.form.immediate) {
        //一级研究方向的码表值
        let codes = this.codes["012"];
        if (codes) {
          for (let code of codes) {
            if (code.cd === newVal) {
              //如果一级选中其他
              if (code.cdDesc === this.otherDirectionStr) {
                for (let code2 of this.codes["013"]) {
                  if (code2.cdDesc === this.otherDirectionStr) {
                    this.form.data.directionLv2TpCode = code2.cd;
                  }
                }
                //如果不是选择中其他
              } else {
                let code1 = this.codes["013"];
                for (let code1Element of code1) {
                  if (code1Element.parentCd === code.cd) {
                    this.form.data.directionLv2TpCode = code1Element.cd;
                    break;
                  }
                }
              }
            }
          }
        }
      } else {
        //设置为非初始化的状态
        this.form.immediate = false;
      }
    }
  },

  methods: {
    handleChangeDegree(value) {
      const that = this;
      if (value) {
        const option = this.eduAndDegcodes.degreeCodes.find(
          i => i.cd === value
        );
        this.form.data.degreeDesc = option.cdDesc;
      } else {
        this.form.data.degreeDesc = null;
        this.form.data.degreeCode = null;
      }
      debugger;
      // console.log(this.form.data);
    },
    //根据学历改变学位信息
    changeXlCode(value) {
      if (value == "045-006") {
        this.form.data.degreeCode = "046-001";
        this.form.data.degreeDesc = "学士";
      } else if (value == "045-008") {
        this.form.data.degreeCode = "046-003";
        this.form.data.degreeDesc = "博士";
      } else if (["045-007", "045-009"].includes(value)) {
        this.form.data.degreeCode = "046-002";
        this.form.data.degreeDesc = "硕士";
      } else {
        this.form.data.degreeCode = null;
        this.form.data.degreeDesc = "无";
      }
    },

    getLearnCodes() {
      let _this = this;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/code/getCodes/memberXlxxCode",
          {
            token: token,
            data: {}
          }
        )
        .then(response => {
          if ((response.data.code = "00000")) {
            let codes = response.data.data;
            _this.eduAndDegcodes.educationCodes = codes["045"];
            _this.eduAndDegcodes.degreeCodes = codes["046"];
          }
        });
    },

    //职称大类改变之默认选中职称小类第一项
    handleTitleLv1Change(value) {
      let codes = this.codes["015"];
      if (codes) {
        for (let code1Element of codes) {
          if (code1Element.parentCd === value) {
            //选中第一个
            this.form.data.titleLv2TpCode = code1Element.cd;
            break;
          }
        }
      }
    },
    //职称大类改变之默认选中职称小类第一项
    handleSecondLv1Change(value) {
      let codes = this.codes["015"];
      if (codes) {
        for (let code1Element of codes) {
          if (code1Element.parentCd === value) {
            //选中第一个
            this.form.data.secondLv2TpCode = code1Element.cd;
            break;
          }
        }
      }
    },
    //拿到选择职称cd
    handleTitleTpCodeChange(value) {
      if (value != null) {
        this.showTitleTpCode = value;
        this.form.data.titleLv2TpCode = value[value.length - 1];
      }
    },
    //第二职称拿到选择职称cd
    handleSecondTpCodeChange(value) {
      if (value != null) {
        this.showSecondTpCode = value;
        this.form.data.secondLv2TpCode = value[value.length - 1];
      }
    },
    //获取基本信息页面码值
    getBaseCodes() {
      let _this = this;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/code/getCodes/memberBasicCode",
          {
            token: token,
            data: {}
          }
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.codes = value.data.data;
            let bigTitleTpCode = this.codes["014"];
            let smallTitleTpCode = this.codes["015"];
            let exTitleTpCode = this.codes["062"];
            let titleTpCodes = [];
            let secondTpCodes = [];

            exTitleTpCode.forEach(item => {
              let bigChildren = [];
              bigTitleTpCode.forEach(itemA => {
                let children = [];
                smallTitleTpCode.forEach(itemB => {
                  if (itemB.parentCd === itemA.cd) {
                    children.push({ value: itemB.cd, label: itemB.cdDesc });
                  }
                });
                if (itemA.parentCd === item.cd) {
                  bigChildren.push({
                    value: itemA.cd,
                    label: itemA.cdDesc,
                    children: children.length === 0 ? null : children
                  });
                }
              });
              titleTpCodes.push({
                value: item.cd,
                label: item.cdDesc,
                children: bigChildren.length === 0 ? null : bigChildren
              });
              secondTpCodes.push({
                value: item.cd,
                label: item.cdDesc,
                children: bigChildren.length === 0 ? null : bigChildren
              });
            });

            this.titleTpCodes = titleTpCodes;
            this.secondTpCodes = secondTpCodes;
          }
        })
        .finally(() => {
          this.initData();
        });
    },

    initPage() {
      let dom = document.getElementsByClassName("myInfo-other-container")[0];
      this.defaultSpan = generateStandardSpan(
        dom.clientWidth,
        this.defaultSensitive
      );
    },

    handleExceed(files, fileList) {
      this.$message({
        message: "只允许选择上传一个图片！",
        type: "error",
        showClose: true
      });
    },

    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        return true;
      }
    },

    handleBeforeOpen() {
      if (!this.form.config.isDisable) {
        this.$confirm("您有修改的数据未保存，是否取消保存？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //点击打开弹窗上传附件
            this.cancel();
            this.$refs["avatar-upload"].$refs["upload-inner"].handleClick();
          })
          .catch(() => {});
      } else {
        this.$refs["avatar-upload"].$refs["upload-inner"].handleClick();
      }
    },

    updateAvatar(file) {
      if (!file.file) {
        return;
      }
      this.form.config.isLoading = true;
      this.form.config.loadingText = "上传中";
      // 使用form表单的数据格式
      const paramsData = new FormData();
      paramsData.append(`file`, file.file);
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {}
      };
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      http
        .post(window.config.api.baseUrl + "/eims-api/avatar/upload", paramsData)
        .then(value => {
          if (value.data.code === "00000") {
            Message.success({ message: "头像已更换", showClose: true });
            //重新触发刷新数据
            //   location.reload()
            //
          }
        })
        .finally(() => {
          this.form.config.isLoading = false;
        });
    },

    //取消修改
    cancel() {
      this.form.config.isDisable = true;
      this.form.data = this.form.copy;
    },

    //校验邮箱字段(邮箱字段不知道为啥,使用自带的校验失效)
    handleMailValidate() {
      let mail = this.form.data.mail;
      let flag = true;
      if (mail) {
        if (!(mail.length >= 1 && mail.length <= 50)) {
          this.$refs.mail.validateState = "error";
          this.$refs.mail.validateMessage = "长度在 50 个字符之内";
          flag = false;
        }
        if (flag) {
          const reg = /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
          if (!reg.test(mail)) {
            this.$refs.mail.validateState = "error";
            this.$refs.mail.validateMessage = "请输入合法邮箱地址";
            flag = false;
          }
        }
      }

      //校验成功
      if (flag) {
        this.$refs.mail.validateState = "success";
        this.$refs.mail.validateMessage = "";
        return true;
      }
    },

    //开始编辑信息或者提交修改信息
    async editInfo() {
      if (!this.form.config.isDisable) {
        let flag = false;

        let mail = this.form.data.mail;

        await this.$refs.form.validate(valid => {
          if (valid) {
            flag = true;
          }
        });

        flag = this.handleMailValidate();

        if (!flag) {
          return;
        }

        //设置日期格式
        this.form.data.birth = this.form.data.birth
          ? this.moment(this.form.data.birth).format("YYYY-MM-DD")
          : null;
        this.form.data.tutorObtainTime = this.form.data.tutorObtainTime
          ? this.moment(this.form.data.tutorObtainTime).format("YYYY-MM-DD")
          : null;

        if (this.form.data.directionLv2 !== this.otherDirectionStr) {
          this.form.data.directionLv2Desc = "";
        }
        if (this.form.data.tutorTpCode === "011-001") {
          this.form.data.tutorObtainTime = null;
        }

        this.form.config.isLoading = true;
        this.form.config.loadingText = "保存中";
        let obj = {
          token: cookie.getCookie("token"),
          data: {
            ...this.form.data
          }
        };
        debugger;
        //保存信息
        http
          .post(window.config.api.baseUrl + "/eims-api/user/share/update", obj)
          .then(value => {
            if (value.data.code === "00000") {
              Message.success({ message: "个人信息修改成功", showClose: true });
              // //重新触发刷新数据
              // setTimeout(function() {
              //   location.reload();
              // }, 500
              // );
            } else {
              this.form.config.isDisable = !this.form.config.isDisable;

              // this.form.data = this.form.copy
            }
          })
          .finally(() => {
            this.form.config.isLoading = false;
            this.getBaseCodes();
          })
          .catch(error => {
            this.form.data = this.form.copy;
          });
      } else {
        this.form.copy = JSON.parse(JSON.stringify(this.form.data));
      }
      this.form.config.isDisable = !this.form.config.isDisable;
    },

    //设置popoer弹出的宽度
    setOptionWidth(event) {
      this.$nextTick(() => {
        let doms = document.getElementsByClassName("el-select-dropdown");
        for (let dom of doms) {
          dom.style.minWidth = event.srcElement.offsetWidth + "px";
        }
      });
    },

    initData() {
      this.form.config.loadingText = this.$options.data().form.config.loadingText;
      this.form.config.isLoading = true;

      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // userId:this.$store.state.MemberManageModule.userId,
          userId: this.userId
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/user/share/userInfo", obj)
        .then(value => {
          if (value.data.code === "00000") {
            this.form.immediate = true;
            this.form.data = value.data.data.userShare;
            this.changeXlCode(this.form.data.educationCode);
            this.baseInfo = {
              userId: this.form.data.userId,
              name: this.form.data.name,
              gender: this.form.data.gender,
              title: this.form.data.title,
              avatar: this.form.data.avatar
            };
            if (this.form.data.titleTpCode == "062-050") {
              this.form.data.showTitleTpCode = [this.form.data.titleTpCode];
            } else {
              let itemB = this.codes["015"].find(
                item => item.cd == this.form.data.titleTpCode
              );
              if (itemB) {
                let itemA = this.codes["014"].find(
                  item => item.cd == itemB.parentCd
                );
                if (itemA) {
                  let itemE = this.codes["062"].find(
                    item => item.cd == itemA.parentCd
                  );
                  this.form.data.showTitleTpCode = [
                    itemE.cd + "",
                    itemA.cd + "",
                    itemB.cd + ""
                  ];
                }
              }
            }

            if (this.form.data.secondTpCode == "062-050") {
              this.form.data.showSecondTpCode = [this.form.data.secondTpCode];
            } else {
              let itemC = this.codes["015"].find(
                item => item.cd == this.form.data.secondTpCode
              );
              if (itemC) {
                let itemA = this.codes["014"].find(
                  item => item.cd == itemC.parentCd
                );
                if (itemA) {
                  let itemF = this.codes["062"].find(
                    item => item.cd == itemA.parentCd
                  );
                  this.form.data.showSecondTpCode = [
                    itemF.cd + "",
                    itemA.cd + "",
                    itemC.cd + ""
                  ];
                }
              }
            }

            // let itemB = this.codes['015'].find( item => item.cd == this.form.data.titleTpCode);
            // if (itemB){
            //   let itemA = this.codes['014'].find(item => item.cd == itemB.parentCd)
            //   this.showTitleTpCode = [itemA.cd+'',itemB.cd+'']
            //
            // // }
          }
        })
        .finally(() => {
          this.form.config.isLoading = false;
          this.$store.dispatch("clearUserId");
          this.$store.dispatch("clearType");
        });

      // http.post(window.config.api.baseUrl + '/eims-api/user/share/baseCode', obj).then(value => {
      //   if (value.data.code === '00000') {
      //     this.codes = value.data.data
      //   }
      // }).finally(() => {
      // })
    }
  },

  //销毁窗口大小变化的事件监听
  destroyed() {
    window.removeEventListener("resize", this.initPage);
  }
};
</script>

<style lang="scss" scoped>
.my-info {
  min-height: calc(100vh - 109px);
  .myInfo-main-container {
    display: flex;
    flex-direction: row;
    padding: 10px;
    height: 90px;
    .main-panel-left {
      width: 110px;
      .user-avatar {
        cursor: pointer;
        background-size: cover;
        display: inline-block;
        border: 2px rgba(238, 244, 251, 0.8) solid;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        &:hover::before {
          transition: all 200ms;
          content: "更换头像";
          line-height: 76px;
          display: inline-block;
          width: 76px;
          height: 76px;
          background-color: #49494970;
          color: #ffffff;
          text-align: center;
          border-radius: 50%;
        }
        &-view {
          background-size: cover;
          display: inline-block;
          border: 2px rgba(238, 244, 251, 0.8) solid;
          border-radius: 50%;
          width: 80px;
          height: 80px;
        }
      }
    }
    .main-panel-right {
      flex: 1;
      margin: 0 10px;
      .user-name-and-gender {
        display: flex;
        flex-direction: column;
        .user-name,
        .user-phone,
        .user-tag {
          margin-bottom: 5px;
        }
        .icon-nan1 {
          color: #0d8efa;
        }
        .icon-nv {
          color: hotpink;
        }
      }
    }
  }
  .myInfo-other-container {
    padding: 20px;
    .dialog-body-data-text {
      font-size: 16px;
      /*padding-right: 10px;*/
      float: left;
      flex: 1;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

/deep/ .el-form-item__label {
  text-align-last: justify;
}

/deep/ .el-input__inner {
  width: calc(100% - 40px);
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-input__suffix {
  position: relative;
  right: 40px;
}

/deep/ .el-select {
  display: block;
}

/*解决el-col换行出现空白的问题*/
.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userInfo.vue